import { memo, useId } from "react";
import { cn } from "@/lib/utils";

export type FieldProps = {
  label?: string;
  errorMessage?: string;
} & React.ComponentProps<"input">;

const Field = ({
  className,
  id,
  type = "text",
  label,
  required,
  errorMessage,
  ...props
}: FieldProps) => {
  const generatedInputId = useId();
  return (
    <div className="grid grid-cols-1 place-content-start gap-2">
      <div className="grid grid-cols-1 place-content-start gap-2 md:gap-2.5">
        {!!label && (
          <label
            htmlFor={id ?? generatedInputId}
            className={cn(
              "text-semantic-text-primary text-base font-normal leading-[130%] md:text-gray-900 md:text-sm md:leading-[20px] md:font-medium",
              {
                "after:content-['*'] after:ml-2 after:text-error": required,
              }
            )}
          >
            {label}
          </label>
        )}
        <input
          id={id ?? generatedInputId}
          type={type}
          className={cn(
            "outline-none w-full py-[12.8px] px-3 text-base leading-[130%] bg-white text-semantic-text-primary border border-solid border-neutral-200 rounded-[12px] transition-colors disabled:cursor-not-allowed disabled:opacity-50 placeholder:text-muted-foreground placeholder:text-base placeholder:leading-[130%] placeholder:transition-opacity placeholder:opacity-100 placeholder:duration-300 focus-visible:border-blue focus-visible:placeholder:opacity-0 md:py-[19.8px] md:px-7.5 md:rounded-[50px] md:text-sm md:leading-[100%] md:placeholder:text-sm md:placeholder:leading-[100%]",
            { "border-error": !!errorMessage },
            className
          )}
          required={required}
          {...props}
        />
      </div>
      {!!errorMessage && (
        <span className="text-error text-sm">{errorMessage}</span>
      )}
    </div>
  );
};

export default memo(Field);
